import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationRecaptchaData } from './Data';

export interface IntegrationRecaptchaState extends BaseIntegrationState {
  recaptchaSiteKey?: string;
}

export class IntegrationRecaptchaModel extends BaseIntegration<IntegrationRecaptchaData, IntegrationRecaptchaState> {
  parse(data: IntegrationRecaptchaData) {
    super.parse(data);
    this.state.recaptchaSiteKey = data.settings?.recaptcha_site_key;
  }

  hasVueComponent() {
    return false;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
